import { capitalize, FCX } from "@datassential/platform-ui-lib";
import cn from "classnames";
import { IoClose } from "react-icons/io5";
import "./FoodSocialPostsFilterTag.scss";

interface Props {
    /** The active posts filter (a month, a food / place, or a custom association); `null` for the default posts. */
    label: string | null;
    onRemove: () => void;
}

/** Tag above the example posts: "All posts" by default, or the active filter, removable with a click. */
const FoodSocialPostsFilterTag: FCX<Props> = ({ label, onRemove, className, testId }) => {
    if (!label) {
        return (
            <span className={cn("FoodSocialPostsFilterTag", className)} data-testid={testId}>
                All posts
            </span>
        );
    }

    return (
        <button
            type="button"
            className={cn("FoodSocialPostsFilterTag", "is-active", className)}
            onClick={onRemove}
            aria-label={`Remove ${label} filter`}
            title="Show all posts"
            data-testid={testId}
        >
            {/* Labels arrive upper-cased ("CHICKEN") or as "June 2026"; Figma shows them in title case. */}
            <span className="FoodSocialPostsFilterTag__label">{capitalize(label)}</span>
            <IoClose className="FoodSocialPostsFilterTag__icon" aria-hidden="true"/>
        </button>
    );
};

export default FoodSocialPostsFilterTag;
